<template>
  <button :class="['btn', 'editor-popover-option-button', {'active': active}]" @click.prevent="$emit('click', $event)" :disabled="disabled">
    <i :class="['fal', icon]" :style="iconStyle" />
    {{title}}
  </button>
</template>

<style scoped>
.editor-popover-option-button {
  width: 40px;
  height: 40px;
  padding: 0;
  margin-right: 0.6rem;
  font-size: 10px;
  text-transform: uppercase;
  border: 1px solid #d2d2d2;
  
}
.editor-popover-option-button.active {
  border: none;
  box-shadow: none;
  color: #FFFFFF;
  background-color: #68ACE8;
}
.editor-popover-option-button > i {
  font-size: 0.9rem;
  display: block;
  padding: 4px 0px 5px 0px;
}
</style>

<script>
export default {
  name: 'EditorPopoverOptionButton',
  props: {
    icon: String,
    title: String,
    active: Boolean,
    disabled: Boolean,
    iconStyle: Object
  }
}
</script>